import numeral from 'numeral';
export function abbreviateNumber(number) {
  return numeral(Math.round(number)).format('0.[0]a');
}
export function fullNumber(number) {
  return numeral(Math.round(number)).format('0,0');
}
export function abbreviateMoney(money) {
  return numeral(Math.round(money)).format('$0.[0]a');
}
export function fullMoney(money) {
  return numeral(Math.round(money)).format('$0,0');
}
export function abbreviatePercentage(number) {
  return numeral(number).format('0%');
}
export function fullPercentage(number) {
  return numeral(number).format('0.[00]%');
}